module.exports = __webpack_public_path__ + "img/img_index_logo_black@2x.edd4785a.png";